var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Fragment,_vm._l((_setup.formats),function(format,index){return _c(_setup.TTag,{key:index,attrs:{"title":format.title,"icon":format.icon,"icon-variant":"default","border-variant":"default"}},[_vm._v("\n    "+_vm._s(format.title)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }